import React, { SVGProps } from 'react';

import { ReactComponent } from '../../assets/svg/search.svg';


export default (props: SVGProps<any>) => <ReactComponent {...props} />;
